import {setMethodsFromAttrs} from '../../modules/util';
import sortByValue from './sortByValue';

const orders = ['natural', 'ascending', 'descending'];
const _attrs = {
  sortByValue: orders[0]
}

const sortableMixin = Base => {
  let Sortable = class extends Base {
    constructor(appendedAttrs) {
      for (let k in _attrs) {
        appendedAttrs[k] = _attrs[k];
      }
      super(appendedAttrs);
    }
  }
  Sortable.prototype.sortByValue = sortByValue;
  setMethodsFromAttrs(Sortable, _attrs);
  return Sortable;
}



export default sortableMixin;
export {orders};


// WEBPACK FOOTER //
// ./layouts/sortable/index.js